/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import useFilms from '../../hooks/useFilms';

import Slider from '../partials/Slider';
import Title from '../typography/Title';

import styles from '../../../styles/blocks/films.module.css';

const propTypes = {
    title: PropTypes.string,
    query: PropTypes.shape({}),
    count: PropTypes.number,
    padded: PropTypes.bool,
    className: PropTypes.string,
    isContainer: PropTypes.bool,
    containerClassName: PropTypes.string,
};

function FilmsBlock({
    title = null,
    query = null,
    count = null,
    padded = false,
    className = null,
    isContainer = false,
    containerClassName = null,
}) {
    const { data: films = null, isLoading = false } = useFilms({ query, count });

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.padded]: padded,
                    [className]: className !== null,
                },
            ])}
        >
            <div
                className={classNames([
                    styles.inner,
                    {
                        [styles.isContainer]: isContainer,
                        [containerClassName]: isContainer && containerClassName !== null,
                    },
                ])}
            >
                {title !== null ? (
                    <Title className={styles.title} size="medium" subtitle>
                        {title}
                    </Title>
                ) : null}
                <Slider cardType="film" items={films} placeholder={isLoading} />
            </div>
        </div>
    );
}

FilmsBlock.propTypes = propTypes;

export default FilmsBlock;
